<template>
  <div>
    <basic-portlet :title="live_feed.name" icon="fa fa-broadcast-tower" :icon-classes="[live_feed_status ? 'kt-font-success' : 'kt-font-danger']">
      <template slot="portlet_actions">
        <div class="btn-group" role="group">
          <button v-if="live_feed_status" type="button" class="btn btn-success">
            On Air
          </button>
          <button v-else type="button" class="btn btn-danger">
            Off Air
          </button>

          <div class="dropdown">
            <button id="live_feed_actions" class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
              Actions
            </button>
            <div class="dropdown-menu" aria-labelledby="live_feed_actions">
              <button v-perms.disable="['api.live-feeds.control']" type="button"
                      class="dropdown-item"
                      @click="control('start', live_feed, true)">
                <i class="fa fa-play" />Start
              </button>
              <button v-perms.disable="['api.live-feeds.control']" type="button"
                      class="dropdown-item"
                      @click="control('stop', live_feed, true)">
                <i class="fa fa-stop" /> Stop
              </button>
              <button v-perms.disable="['api.live-feeds.control']" type="button"
                      class="dropdown-item"
                      @click="control('restart', live_feed, true)">
                <i class="fa fa-dot-circle" />Restart
              </button>
              <button v-perms.disable="['web.live-feeds.edit']" class="dropdown-item"
                      @click="windowOpen(`/live-feeds/${live_feed.uuid}/edit`)">
                <i class="fa fa-pencil-alt" />Edit
              </button>
              <button v-perms.disable="['api.live-feeds.destroy']" type="button"
                      class="dropdown-item"
                      style="color:red"
                      @click="destroy(live_feed, true)">
                <i class="fa fa-trash" />Delete
              </button>
            </div>
          </div>
        </div>
      </template> <!-- End Portlet Actions -->

      <div class="row border-bottom mb-4">
        <div class="col-12">
          <h5>Feeds</h5>
        </div>
      </div>

      <div class="row mb-4">
        <div v-for="(playlist, playlist_index) in live_feed.premium_config.playlists"
             :key="`${live_feed.uuid}_playlist_${playlist_index}`"
             class="col-12 col-md-4 mb-4">
          <live-feed-playlist-card :playlist-index="playlist_index + 1" :playlist-data="playlist" />
        </div>
      </div>

      <div class="row border-bottom mb-4">
        <div class="col-12">
          <h5>Outputs</h5>
        </div>
      </div>

      <div class="row mb-4">
        <div v-for="(output, output_index) in live_feed.premium_config.outputs"
             :key="`${live_feed.uuid}_output_${output_index}`"
             class="col-12 col-md-4 mb-4">
          <live-feed-output-card :live-feed-uuid="live_feed.uuid" :output="output" :output-index="output_index + 1" />
        </div>
      </div>
    </basic-portlet>
    <quick-alert-modal v-bind="quick_alert" />
  </div>
</template>

<script>

import BasicPortlet from "VueComponents/BasicPortlet";
import LiveFeedsMixin from "VueMixins/Feeds/LiveFeedsMixin";
import LiveFeedPlaylistCard from "VuePartials/LiveFeeds/LiveFeedPlaylistCard";
import LiveFeedOutputCard from "VuePartials/LiveFeeds/LiveFeedOutputCard";

export default {

  components: {
    LiveFeedOutputCard,
    LiveFeedPlaylistCard,
    BasicPortlet,
  },

  mixins: [LiveFeedsMixin],

  data: () => ({
    outputs: window.outputs,
  }),

  beforeMount() {
    this.live_feed_status = this.checkStatus(this.live_feed);
  },

};
</script>
